import React, { useState } from 'react';
import ListBreeds from './ListBreeds.js';
import AddBreed from './AddBreed.js';
import { ListButton, AddButton, FAB } from '../../shared/ActionButtons';

export const Breeds = ({ screen, setScreen, hideHeader }) => {
  const [localScreen, setLocalScreen] = useState("list");

  // Use passed screen/setScreen if provided, otherwise use local state
  const currentScreen = screen !== undefined ? screen : localScreen;
  const setCurrentScreen = setScreen || setLocalScreen;

  return (
    <>
      {!hideHeader && (
        <div className="content-header">
          <div className="action-buttons">
            <ListButton
              isActive={currentScreen === "list"}
              onClick={() => setCurrentScreen("list")}
            />
            <AddButton
              isActive={currentScreen === "add"}
              onClick={() => setCurrentScreen("add")}
            />
          </div>
        </div>
      )}

      {(currentScreen === "list") && <ListBreeds/>}
      {(currentScreen === "list") && <FAB onClick={() => setCurrentScreen("add")} />}
      {(currentScreen === "add") &&
        <AddBreed
          onSuccess={() => setCurrentScreen("list")}
        />
      }
    </>
  );
}

// Action buttons component for use in hub header
export const BreedsActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton
      isActive={screen === "list"}
      onClick={() => setScreen("list")}
    />
    <AddButton
      isActive={screen === "add"}
      onClick={() => setScreen("add")}
    />
  </div>
);

export default Breeds;
